// Gli avatar dei pops per profilo e per nome, letti una volta e condivisi: il grafico del
// Runtime e le altre viste li usano senza chiedere ognuna i profili.
import { useEffect, useState } from 'react';
import { api } from './api';

let cache: Promise<Map<string, string>> | null = null;

function load(): Promise<Map<string, string>> {
  cache ??= api.profiles().then(
    (rows) => {
      const m = new Map<string, string>();
      for (const r of rows) {
        m.set(r.id, r.avatar);
        m.set(r.label.toLowerCase(), r.avatar);
      }
      return m;
    },
    () => {
      cache = null; // al prossimo giro si riprova
      return new Map<string, string>();
    },
  );
  return cache;
}

/** L'avatar di un pop dato il profilo o il nome; null se non si conosce. */
export function useFace(profile?: string, name?: string): string | null {
  const [face, setFace] = useState<string | null>(null);
  useEffect(() => {
    let alive = true;
    void load().then((m) => {
      if (!alive) return;
      const byName = name
        ? (m.get(name.toLowerCase()) ?? m.get(name.toLowerCase().replace(/\s+\d+$/, '')))
        : undefined;
      setFace((profile && m.get(profile)) || byName || null);
    });
    return () => {
      alive = false;
    };
  }, [profile, name]);
  return face;
}
